.container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 125px;
  gap: 8px;
}

.iconSuccess {
  color: var(--tuna-palette-success-main);
}

/* Holds the check's width when unpicked, so Vote and Unvote line up row to row. */
.iconHidden {
  visibility: hidden;
}

.unvoteText {
  color: var(--tuna-content-secondary);
}
